export default {"src":"/_next/static/media/offer_back.6386922a.svg","height":330,"width":545,"blurWidth":0,"blurHeight":0};